module.exports = __webpack_public_path__ + "static/img/jiqi-0.1bbced6.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/page-one/img/jiqi-0.png
// module id = UxcU
// module chunks = 0